import { FlipToBootSetStatusEnum } from "../flipToBoot.enum";
import { FlipToBootErrorStatusInterface, FlipToBootInterface } from "../flipToBoot.interface";

export abstract class PowerSettingsBase {
	abstract setAlwaysOnUSBStatus(isEnabled: boolean): Promise<boolean>;
	abstract getAlwaysOnUSBCapability(): Promise<boolean>;

	abstract setUSBCharging(isEnabled: boolean): Promise<boolean>;
	abstract getUSBChargingCapability(): Promise<boolean>;

	abstract getAirplaneModeCapability(): Promise<boolean>;
	abstract setAirplaneMode(isEnabled: boolean): Promise<boolean>;
	abstract setAirplaneModeAutoDetection(isEnabled: boolean): Promise<boolean>

	abstract setEasyResume(isEnabled: boolean): Promise<boolean>;
	abstract getEasyResumeCapability(): Promise<boolean>;

	abstract setFlipToBoot(status: FlipToBootSetStatusEnum): Promise<FlipToBootErrorStatusInterface>;
	abstract getFlipToBoot(): Promise<FlipToBootInterface>
}
